import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    heroContainer: {
        justifyContent: "center",
        paddingHorizontal: 24,
        alignItems: "center",
        paddingBottom: 64,
        paddingTop: 160,
        width: "100%",
        gap: 32
    },
    heroButtonsContainer: {
        justifyContent: "center",
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 16
    },
    featuresContainer: {
        justifyContent: "center",
        paddingHorizontal: 24,
        flexDirection: "row",
        alignSelf: "center",
        paddingBottom: 80,
        flexWrap: "wrap",
        maxWidth: 1200,
        width: "100%",
        gap: 24
    },
    featureIconContainer: {
        justifyContent: "center",
        alignItems: "center",
        height: 56,
        width: 56
    },
    footerContainer: {
        justifyContent: "center",
        paddingHorizontal: 24,
        alignItems: "center",
        paddingVertical: 32,
        borderTopWidth: 1,
        marginTop: "auto",
        width: "100%"
    },
    headerContainer: {
        paddingHorizontal: 24,
        flexDirection: "row",
        alignItems: "center",
        position: "absolute",
        paddingVertical: 16,
        width: "100%",
        zIndex: 10,
        right: 0,
        top: 0
    },
    featureCard: {
        paddingHorizontal: 24,
        paddingVertical: 32,
        borderWidth: 1,
        minWidth: 280,
        flex: 1,
        gap: 16
    },
    headerRight: {
        flexDirection: "row",
        alignItems: "center",
        gap: 12
    },
    heroTextContainer: {
        alignItems: "center",
        maxWidth: 800,
        width: "100%",
        gap: 16
    },
    heroSubtitle: {
        textAlign: "center",
        lineHeight: 28,
        opacity: 0.8
    },
    footerText: {
        textAlign: "center",
        opacity: 0.6
    },
    heroTitle: {
        textAlign: "center"
    },
    featureTextContainer: {
        gap: 8
    },
    featureDescription: {
        lineHeight: 24,
        opacity: 0.7
    },
    logo: {
        height: 150,
        width: 150
    },
    scrollContent: {
        flexGrow: 1
    },
    headerLeft: {
        flex: 1
    },
    container: {
        flex: 1
    }
});

export default stylesheet;
